import React from "react";
import "./SimpleTextAreaField.css";

function SimpleTextAreaField({
  label = "Campaign Context",
  placeholder = "Type here...",
  labelPosition = "top-left",      // top-left | top-right | left | right | bottom-left | bottom-right
  wrapperClassName = "",
  textareaClassName = "",
  id,
  customWidth,
  rows = 5,                        // fixed height; scroll after this many rows
  disabled = false,
  error = "",
  helperText = "",
  ...textareaProps                 // value, onChange, maxLength, etc.
}) {
  const inputId = id || `sta-${Math.random().toString(36).slice(2, 9)}`;

  return (
    <div
      className={[
        "stf-wrap",
        `stf-label-pos-${labelPosition}`,
        "sta-wrap",
        wrapperClassName,
        disabled ? "is-disabled" : "",
        error ? "is-error" : "",
      ].join(" ")}
      style={{ width: customWidth || "100%", maxWidth: customWidth || "100%"}}
    >
      <label htmlFor={inputId} className="stf-label">
        {label}
      </label>

      <textarea
        id={inputId}
        className={["sta-input", textareaClassName].join(" ")}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        aria-invalid={!!error}
        {...textareaProps}
      />

      {(helperText || error) && (
        <div className={["sta-helper", error ? "is-error" : ""].join(" ")}>
          {error || helperText}
        </div>
      )}
    </div>
  );
}

export default SimpleTextAreaField;
